import { defineMessages } from 'react-intl';
import type { IndustryEnum } from '@foundershub/api-client';

export const industryLabels = defineMessages<IndustryEnum>({
  automotive: {
    defaultMessage: 'Automotive',
    description: 'industry label',
  },
  banking: {
    defaultMessage: 'Banking',
    description: 'industry label',
  },
  'capital-markets': {
    defaultMessage: 'Capital markets',
    description: 'industry label',
  },
  'consumer-goods': {
    defaultMessage: 'Consumer goods',
    description: 'industry label',
  },
  cybersecurity: {
    defaultMessage: 'Cybersecurity',
    description: 'industry label',
  },
  'defense-and-intelligence': {
    defaultMessage: 'Defense and intelligence',
    description: 'industry label',
  },
  education: {
    defaultMessage: 'Education',
    description: 'industry label',
  },
  energy: {
    defaultMessage: 'Energy',
    description: 'industry label',
  },
  'financial-services': {
    defaultMessage: 'Financial services',
    description: 'industry label',
  },
  gaming: {
    defaultMessage: 'Gaming',
    description: 'industry label',
  },
  government: {
    defaultMessage: 'Government',
    description: 'industry label',
  },
  'healthcare-and-life-sciences': {
    defaultMessage: 'Healthcare and Life Sciences',
    description: 'industry label',
  },
  'horizontal-cross-industry': {
    defaultMessage: 'Horizontal (cross-industry)',
    description: 'industry label',
  },
  insurance: {
    defaultMessage: 'Insurance',
    description: 'industry label',
  },
  manufacturing: {
    defaultMessage: 'Manufacturing',
    description: 'industry label',
  },
  'media-and-entertainment': {
    defaultMessage: 'Media and entertainment',
    description: 'industry label',
  },
  nonprofit: {
    defaultMessage: 'Nonprofit',
    description: 'industry label',
  },
  'public-safety-and-justice': {
    defaultMessage: 'Public safety and justice',
    description: 'industry label',
  },
  retail: {
    defaultMessage: 'Retail',
    description: 'industry label',
  },
  sustainability: {
    defaultMessage: 'Sustainability',
    description: 'industry label',
  },
  telecommunications: {
    defaultMessage: 'Telecommunications',
    description: 'industry label',
  },
});
